import 'chartjs-plugin-datalabels';
import { Bar } from "react-chartjs-2";
import getHost from 'utils/url';


const SourcesCountChart = ({ data }) => {

    const sources = [...new Set(data.map((item) => getHost(item.state === 2 ? item.urlBackup : item.url)))];

    const temp = sources.map((source) => {
        const data2 = data.filter((item) => getHost(item.state === 2 ? item.urlBackup : item.url) === source);
        const conteoStateAll = data2.length;
        const conteoState1 = data2.filter((item) => item.state === 1).length;
        const conteoState2 = data2.filter((item) => item.state === 2).length;
        const conteoState4 = data2.filter((item) => item.state === 4).length;

        return {
            source: source,
            name: source,
            conteoStateAll,
            conteoState1,
            conteoState2,
            conteoState4,
        };
    });

    let datosPorServidor = []
    if (temp.length > 5) {
        datosPorServidor = temp.slice(0, 5)
    } else {
        datosPorServidor = temp
    }

    const getHappyColor = () => {
        const randomHue = Math.random() * 360; // Tonos de 0 a 360 grados
        const saturation = 80; // Saturación
        const lightness = 65; // Brillo
        return `hsla(${randomHue}, ${saturation}%, ${lightness}%, 0.8)`;
    };

    const chartData = {
        //labels: serversName,
        labels: datosPorServidor.map((item) => item.name),
        /*
        datasets: [
            {
                categoryPercentage: 1,
                barPercentage: 0.4,
                //barThickness: 10,
                //maxBarThickness: 20,
                minBarLength: 1,
                label: 'Fuentes',
                data: countByServer,
                //backgroundColor: 'rgba(75,192,192,0.4)', // Color de fondo de las barras
                //borderColor: 'rgba(75,192,192,1)', // Color del borde de las barras
                backgroundColor: randomColors,
                borderColor: randomColors.map(color => color.replace('0.4', '1')), // Establecer el borde con opacidad completa
                //backgroundColor: data.map(item => getRedToGreenColor(currentTimeInSeconds - item.time, minTime, maxTime)),
                //borderColor: data.map(item => getRedToGreenColor(currentTimeInSeconds - item.time, minTime, maxTime)),
                borderWidth: 1,
            },
        ],
        */

        datasets: [
            {
                label: 'Todo',
                data: datosPorServidor.map((item) => item.conteoStateAll),
                backgroundColor: '#50C499',
                borderColor: '#50C499',
                borderWidth: 1,
                minBarLength: 5,
                datalabels: {
                    align: 'center',
                    anchor: 'center'
                }
            },
            {
                label: 'Online',
                data: datosPorServidor.map((item) => item.conteoState1),
                backgroundColor: '#8DC453',
                borderColor: '#8DC453',
                borderWidth: 1,
                minBarLength: 5,
                borderRadius: 5,
                borderSkipped: false,
            },
            {
                label: 'Fallidos',
                data: datosPorServidor.map((item) => item.conteoState4),
                backgroundColor: '#c45d53',
                borderColor: '#c45d53',
                borderWidth: 1,
                minBarLength: 5,
            },
            {
                label: 'Backup',
                data: datosPorServidor.map((item) => item.conteoState2),
                backgroundColor: '#c4ac53',
                borderColor: '#FFB705',
                borderWidth: 1,
                minBarLength: 5,
            },
        ]
    };

    // Configuración de la gráfica
    //let delayed;

    const chartOptions = {
        type: 'bar',
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.5,
        indexAxis: 'x',
        scales: {
            x: {
                title: {
                    type: 'time',
                    display: true,
                    text: 'Servidor',
                    font: {
                        size: 16
                    }
                },
                ticks: {
                    font: {
                        size: 12
                    },
                    /*
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                        //return formatTime(value);
                        return value;
                    }
                    */
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Numero de Fuentes',
                    font: {
                        size: 16
                    }
                },
                ticks: {
                    stepSize: 5,
                    font: {
                        size: 12
                    },
                }
            },
        },
        plugins: {
            plugins: {
                datalabels: {
                    labels: {
                        title: {
                            color: 'white'
                        }
                    },
                    align: 'center',
                    anchor: 'center',
                    color: '#fff',
                    display: function (context) {
                        return context.dataset.data[context.dataIndex] > 15;
                    },
                    formatter: Math.round
                },
            },
            tooltip: {
                callbacks: {
                    //label: (tooltipItem) => formatTime(tooltipItem.raw),
                    //label: (tooltipItem) => tooltipItem.raw,
                },
            },
            title: {
                display: true,
                text: 'Estado por Fuente',
                font: {
                    size: 18
                }
            }
        },
        /*
        animation: {
            onComplete: () => {
                delayed = true;
            },
            delay: (context) => {
                let delay = 0;
                if (context.type === 'data' && context.mode === 'default' && !delayed) {
                    delay = context.dataIndex * 100 + context.datasetIndex * 200;
                }
                return delay;
            },
        },
        */
    };

    return (
        <Bar data={chartData} options={chartOptions} className="mt-5" />
    );
};

export default SourcesCountChart